import React from 'react'
import proj1 from "../assets/project-1.png"
import proj2 from "../assets/project-2.png"
import proj3 from "../assets/project-3.png"
import proj4 from "../assets/project-4.png"
import proj5 from "../assets/project-5.png"
import proj6 from "../assets/project-6.png"
import search from "../assets/search.png"
import styled from 'styled-components'

function Projects() {
  return (
    <MainCont id='project'>
      <h1>
        Check Out my Projects!
      </h1>
      <Cont>
        <ProjCont>
          <ProjInfoCont>
            <h2>
              Sports News Website
            </h2>
          </ProjInfoCont>
          <ProjButton>
              <a href='https://github.com/Ma-urj/Sports_News_Website' target='_blank'>Github</a>
          </ProjButton>
          <ProjImg src={proj1}/>
        </ProjCont>
        <ProjCont>
          <ProjInfoCont>
            <h2>
              Shadan Football League Website
            </h2>
          </ProjInfoCont>
          <ProjButton>
              <a href='https://sfl2023-786.web.app' target='_blank'>Live</a>
              <a href='https://github.com/Ma-urj/SFL' target='_blank'>Github</a>
          </ProjButton>
          <ProjImg src={proj2}/>
        </ProjCont>
        <ProjCont>
          <ProjInfoCont>
            <h2>
              Sign Language Translator
            </h2>
          </ProjInfoCont>
          <ProjButton>
              <a href='https://github.com/Ma-urj/Sign-Language-Translator' target='_blank'>Github</a>
          </ProjButton>
          <ProjImg src={proj3}/>
        </ProjCont>
        <ProjCont>
          <ProjInfoCont>
            <h2>
              Pokedex App
            </h2>
          </ProjInfoCont>
          <ProjButton>
              <a href='https://github.com/Ma-urj/PokedexApp' target='_blank'>Github</a>
          </ProjButton>
          <ProjImg src={proj4}/>
        </ProjCont>
        <ProjCont>
          <ProjInfoCont>
            <h2>
              Food Deliver App
            </h2>
          </ProjInfoCont>
          <ProjButton>
              <a href='https://github.com/Ma-urj/FoodDeliveryApp' target='_blank'>Github</a>
          </ProjButton>
          <ProjImg src={proj5}/>
        </ProjCont>
        <ProjCont>
          <ProjInfoCont>
            <h2>
              Weather App
            </h2>
          </ProjInfoCont>
          <ProjButton>
              <a href='https://github.com/Ma-urj/WeatherApp' target='_blank'>Github</a>
          </ProjButton>
          <ProjImg src={proj6}/>
        </ProjCont>
      </Cont>
    </MainCont>
  )
}

export default Projects

const ProjButton = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background: #333333;
  padding: 3vh 0;
  a{
    margin: 0 3vh;
    text-decoration: none;
    background: none;
    border: 1px solid white;
    padding: 1vh 2vw;
    color: white;
    &:hover{
      color: black;
      background: white;
    }
  }
`

const MainCont = styled.div`
  padding: 15vh 6vw;
  background: #F2EDD7FF;
  color: black;
  transition: 800ms ease-in-out!important;
  h1{
    padding-bottom: 5vh;
    font-size: 3em;
    @media(max-width: 767px){
      font-size: 1.5em;
    }
    @media(max-width: 281px){
        font-size: 1em;
    }
  }
`

const ProjCont = styled.div`
  position: relative;
  overflow: hidden;
  display: block;
  aspect-ratio: 16/9;
`

const Cont = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 15px;
  grid-row-gap: 15px;
  @media(max-width: 912px){
    grid-template-columns: repeat(1, 1fr);
  }
`

const ProjImg = styled.img`
  height: ${(9*(40))/16}vw;
  width: 40vw;
  object-fit: cover;
  object-position: center;
  @media(max-width: 912px){
    height: ${(9*(80))/16}vw;
    width: 80vw;
  }
`

const ProjInfoCont = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  inset: 0;
  align-items: center;
  justify-content: space-evenly;
  background: rgba(255,255,255,0.8);
  @media(max-width: 281px){
    h2{
      font-size: 1em;
      margin-bottom: 5vh;
    }
  }
`